import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { RentalConditions } from './types/RentalConditions';

export default (makeCall: MakeCall) => (id: number) =>
  makeCall<RentalConditions>(
    'GET',
    `/api/v2/bookings/rental-conditions/id/${id}`,
  );
